<template>
    <div class="microform" :edit="edit">

        <template v-if="!showedit && data">
            <h3>{{dominios.nivel[data.level]}}</h3>
            <h2>{{data.study.name}}, {{data.university.name}}, {{data.year}}</h2>
            <p v-if="data.elu_year">Promoción ELU: {{data.elu_year}} </p>
        </template>

        <a class="editar" v-if="data.dataId" @click="editData">editar</a>
        <a class="eliminar" v-if="data.dataId" @click="showerase = true">Eliminar</a>


        <template v-if="showedit">

            <ValidationObserver ref="form" v-slot="{failed,valid}">

                <form class="paso row-between fww" @submit.prevent="validate" :valid="valid" autocomplete="off">

                    <template v-if="!notelu">



                        <div class="contenedor-input row-start only-one-option" v-if="!elu">
                            <ValidationProvider rules="required" v-slot="{ errors,ariaInput,ariaMsg,classes }">
                                <input type="checkbox" :value="true" name="haselu" :id="'haselu-'+pos" v-model="data.haselu">
                                <label :class="classes" :for="'haselu-'+pos">Soy Egresado de la Escuela de Liderazgo
                                    Universitario (ELU)</label>
                                <span v-bind="ariaMsg" class="custom-error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>

                        <div class="contenedor-input" v-if="data.haselu">
                            <ValidationProvider rules="required" v-slot="{ errors,ariaInput,ariaMsg,classes }">
                                <year-datepicker :class="classes" :label="'Año de promoción ELU'" :minpage="new Date()"
                                    v-model="data.elu_year" :name="'elu_year'">
                                </year-datepicker>
                                <span v-bind="ariaMsg" class="custom-error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>

                        <figure v-if="data.haselu">
                            Selecciona estudios de acceso a ELU
                        </figure>

                    </template>

                    <div class="contenedor-input full-width">
                        <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                            <autocomplete :class="classes" :name="'study'" :label="'Titulación'" :type="'study'"
                                v-model="data.study" :idkey="'id'" @input="setDominioNivel($event)">
                            </autocomplete>
                            <span v-bind="ariaMsg" class="custom-error" v-if="errors[0]">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>


                    <div class="contenedor-input full-width pt-0">
                        <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                            <label for="nivel">Nivel</label>
                            <select id="nivel" name="nivel" v-model="data.level" class="pretty" :class="classes">
                                <option name="myBrowser" placeholder="" disabled>Selecciona*</option>
                                <option :key="key" v-for="(nivel, key) in nivelesFiltered.length > 0 ? nivelesFiltered : setNiveles(data.study.levels)" name="myBrowser"
                                    :value="nivel.id">
                                    {{ nivel.value }}
                                </option>
                            </select>
                            <span v-bind="ariaMsg" class="custom-error" v-if="errors[0]">{{ errors[0] }}</span>
                
                            <small v-if="data.level == 3 || data.level == '3'" class="small-info">*Para el nivel académico seleccionado, recuerda que el año máximo permitido como año de promoción es 2009</small>
                        </ValidationProvider>
                    </div>


                    <div class="contenedor-input half pt-0">
                        <ValidationProvider rules="required" v-slot="{ errors,ariaInput,ariaMsg,classes }">
                            <autocomplete :class="classes" :name="'university'" :label="'Universidad'"
                                :type="(!ownonlyufv) ? 'university' : 'ufv'" v-model="data.university" :idkey="'id'" ref="university"></autocomplete>
                            <span v-bind="ariaMsg" class="custom-error">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>



                    <div class="contenedor-input half">
                        <ValidationProvider rules="required" v-slot="{ errors,ariaInput,ariaMsg,classes }">
                            <year-datepicker :class="classes" :label="'Año de promoción'" :minpage="new Date()" :maxpage="(data.level == 3 || data.level == '3') ? new Date('2009-12-31') : null"
                                v-model="data.year" :name="'year'">
                            </year-datepicker>
                            <span v-bind="ariaMsg" class="custom-error">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>



                    <div class="full-width row-center">
                        <button class="boton-azul" :loading="loading">Guardar</button>
                    </div>


                </form>

            </ValidationObserver>

        </template>



        <popup-confirmacion v-if="showerase" :loading="loadingerase" :how="'borraracademico'" @accept="requestErase"
            @cancel="showerase = false" :isnegative="true">
        </popup-confirmacion>


    </div>
</template>


<script>

    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'academico',
        props: ['values', 'showedit', 'notelu', 'elu', 'onlyufv','pos'],
        mounted() {
            if (this.values) {
                this.data = this.values;
                if (this.values.elu_year) {
                    this.data.haselu = true;
                }else{
                    this.data.haselu = false;
                }
            }

            if (this.elu) {
                this.data.haselu = true;
            }
            this.ownonlyufv = this.onlyufv;

            this.edit = this.showedit;
        },
        data: () => ({
            data: {
                university: {},
                study: '',
                level: '',
                elu_year: '',
                year: '',
                haselu: false
            },
            edit: false,
            loading: false,
            loadingerase: false,
            showerase: false,
            ownonlyufv: false,
            currentId: null
        }),
        methods: {
            ...mapActions(['deleteAcademico', 'saveAcademico', 'setNiveles']),
            requestErase() {
                let data = [this.data.dataId];
                data = { dataId: data }
                this.deleteAcademico(data).then(r => {
                    if (r) {
                        this.$emit('refresh');
                        this.showerase = false;
                    }
                })
            },
            validate() {
                this.$refs.form.validate().then(success => {
                    if (success) {
                        this.loading = true;


                        let dataForm = JSON.parse(JSON.stringify(this.data))

                        if (typeof this.data.study == 'object') {
                            dataForm.study = this.data.study_id;
                        }

                        if (typeof this.data.university == 'object') {
                            dataForm.university = this.data.university.id;
                        }

                        if(!this.data.haselu){
                            dataForm.elu_year = '';
                        }

                        this.saveAcademico(dataForm).then(r => {
                            this.loading = false;
                            this.currentId = null;
                            if (r) {
                                this.edit = false;
                                this.$emit('refresh')
                            }
                        })
                    }
                });
            },
            cancel() {
                this.$emit('cancel');
                this.edit = false;
            },
            setDominioNivel(event) {
                this.data.level = '';
                this.data.study = event.id
                this.setNiveles(event.levels);
            },
            editData() { 
                if(!this.currentId){
                    this.currentId = this.data.dataId;
                } else {
                    if(this.currentId !== this.data.dataId){
                        this.currentId = this.data.dataId;
                    } 
                }
                this.setNiveles(this.data.study.levels);
                this.$emit('edit', this.currentId);
            }
        },
        computed: {
            ...mapGetters({
                dominios: 'getDominios', nivelesFiltered: 'getCurrentNiveles'
            })
        },
        watch : {
            'data.haselu'(){
                    this.ownonlyufv = !this.data.haselu;
                    if(this.data.haselu && !this.data.dataId){
                        this.data.university = '';
                        this.$refs.university.erase();
                    }
                
            }
        }


    }
</script>